import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const SignIn = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate('/');
  };

  return (
    <div className="relative flex items-center justify-center min-h-screen w-full overflow-hidden bg-gradient-to-br from-orange-50 to-orange-100">
      {/* Background pattern */}
      <div className="absolute inset-0 grid grid-cols-4 grid-rows-3 gap-4 z-0">
        {Array(12).fill().map((_, i) => (
          <div key={i} className="rounded-lg bg-gradient-to-br from-orange-200 to-orange-100 opacity-50"></div>
        ))}
      </div>
      
      {/* Main container */}
      <div className="relative z-10 flex flex-row w-full max-w-4xl bg-white rounded-lg shadow-xl overflow-hidden">
        
        {/* Form side */}
        <div className="w-full md:w-1/2 p-8 md:p-12">
          <div className="flex items-center mb-8">
            <img 
              src="/asset/Logo/hireeLogo.png" 
              alt="Hiree Logo" 
              className="h-10 w-auto"
            />
            <span className="ml-3 text-xl text-gray-600">Sign in to your account</span>
          </div>
          
          <div className="space-y-4">
            <h3 className="text-lg font-medium text-gray-700 text-center mb-6">Choose your account type</h3>
            
            <Link 
              to="/login/regular" 
              className="block w-full py-4 px-6 border-2 border-gray-300 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors text-center"
            >
              <div className="flex items-center justify-center space-x-3">
                <svg className="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <div>
                  <div className="font-medium text-gray-900">Job Seeker</div>
                  <div className="text-sm text-gray-500">Find your next opportunity</div>
                </div>
              </div>
            </Link>
            
            <Link 
              to="/login/business" 
              className="block w-full py-4 px-6 border-2 border-gray-300 rounded-lg hover:border-orange-500 hover:bg-orange-50 transition-colors text-center"
            >
              <div className="flex items-center justify-center space-x-3">
                <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-4m-5 0H3m2 0h3M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                <div>
                  <div className="font-medium text-gray-900">Business Owner</div>
                  <div className="text-sm text-gray-500">Hire talented staff</div>
                </div>
              </div>
            </Link>
          </div>
          
          <div className="text-center mt-8">
            <p className="text-sm text-gray-600">
              Don't have an account?{' '}
              <Link to="/signup" className="text-orange-500 hover:text-orange-600">
                Sign up
              </Link>
            </p>
          </div>
        </div>
        
        {/* Video side */}
        <div className="hidden md:block md:w-1/2 relative">
          <button 
            onClick={handleClose}
            className="absolute top-4 right-4 z-20 p-2 bg-white bg-opacity-70 rounded-full hover:bg-opacity-100"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
          <video autoPlay muted loop className="absolute inset-0 w-full h-full object-cover">
            <source src="/asset/SignInPage/video1.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="absolute inset-0 bg-black bg-opacity-30"></div>
          <div className="absolute bottom-8 left-8 z-20 text-white">
            <h2 className="text-2xl font-bold mb-2">Welcome Back</h2>
            <p className="text-sm opacity-90">Sign in to continue your journey</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
